// src/layouts/legal/Privacy.js
import React from "react";
import { Container, Typography, Link } from "@mui/material";

export default function Privacy() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography paragraph>
        We explain what data we collect, how we use it, and your rights.
      </Typography>

      <Typography variant="h5" gutterBottom>
        1. Data We Collect
      </Typography>
      <Typography paragraph>
        Identity/contact details, usage logs, and data retrieved from integrations (e.g.,
        QuickBooks) as required for features you enable.
      </Typography>

      <Typography variant="h5" gutterBottom>
        2. Purpose
      </Typography>
      <Typography paragraph>
        Authentication, providing features, support, security, analytics, and legal compliance.
      </Typography>

      <Typography variant="h5" gutterBottom>
        3. Sharing
      </Typography>
      <Typography paragraph>
        We share data with sub-processors strictly to operate the Service (hosting, monitoring,
        email). No sale of personal data.
      </Typography>

      <Typography variant="h5" gutterBottom>
        4. Security & Retention
      </Typography>
      <Typography paragraph>
        We use industry-standard security measures. Data is kept as long as necessary for the
        purposes described.
      </Typography>

      <Typography variant="h5" gutterBottom>
        5. Your Rights
      </Typography>
      <Typography paragraph>
        You may request access, correction, or deletion. Contact:{" "}
        <Link href="mailto:dpo@budgycraft.com">dpo@budgycraft.com</Link>.
      </Typography>
    </Container>
  );
}
